import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    cardContentPadding: {
      paddingLeft: '24px',
    },
    button: {
      fontSize: theme.typography.pxToRem(11),
      textTransform: 'inherit',
      minWidth: 'inherit',
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent',
        boxShadow: 'none',
      },
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      textAlign: 'right',
    },

    primary: {
      color: '#4D4F5C',
      fontSize: 13,
      fontWeight: 600,
      textTransform: 'capitalize',
      textAlign: 'left',
      wordBreak: 'break-word',
    },

    secondary: {
      // color: '#2C2C2E',
      fontSize: 12,
      fontWeight: 400,
      maxWidth: '60%',
      wordBreak: 'break-word',
      color: '#11A71B',

      '& .inactive': {
        color: '#FA5252',
      },

      '& span:last-child': {
        display: 'block',
        color: '#4D4F5C',
        fontSize: 11,
        textTransform: 'capitalize',
      },
    },
  };
});

const listItemsStyles = makeStyles((theme) => {
  return {
    root: {
      width: '100%',
      padding: '0 5px 8px',
      borderBottom: '1px solid #EEE',
      marginBottom: 10,
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      paddingLeft: 30,
      paddingRight: 30,
    },
  };
});

export { useStyles, listTextStyles, customCardStyles, listItemsStyles };
